import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate, Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import '../styles/admin.css';

const AdminLayout = () => {
    const navigate = useNavigate();
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    let adminUser = null;
    try {
        adminUser = JSON.parse(localStorage.getItem('adminUser'));
    } catch (error) {
        console.error("Failed to parse admin user", error);
        localStorage.removeItem('adminUser');
    }

    useEffect(() => {
        if (!adminUser) {
            navigate('/admin/login');
        }
    }, [adminUser, navigate]);

    // Close menu when route changes on mobile
    useEffect(() => {
        setIsMobileMenuOpen(false);
    }, [navigate]);

    const handleLogout = () => {
        localStorage.removeItem('adminUser');
        navigate('/admin/login');
    };

    if (!adminUser) return null;

    return (
        <div className="admin-layout">
            {/* Mobile Header */}
            <header className="admin-mobile-header">
                <div className="admin-mobile-logo">Hashtag Admin</div>
                <button
                    className="admin-mobile-toggle"
                    onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                >
                    {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
                </button>
            </header>

            {/* Sidebar */}
            <aside className={`admin-sidebar ${isMobileMenuOpen ? 'open' : ''}`}>
                <div className="admin-sidebar-header">
                    <h1>Hashtag Admin</h1>
                </div>
                <nav className="admin-nav">
                    <ul>
                        <li>
                            <Link to="/admin/dashboard" className="admin-nav-link">
                                Dashboard
                            </Link>
                        </li>
                        <li>
                            <Link to="/admin/properties/add" className="admin-nav-link">
                                Add Property
                            </Link>
                        </li>
                        <li>
                            <Link to="/admin/bookings" className="admin-nav-link">
                                Booking Inquiries
                            </Link>
                        </li>
                        <li>
                            <Link to="/admin/messages" className="admin-nav-link">
                                Contact Messages
                            </Link>
                        </li>
                        <li>
                            <Link to="/" className="admin-nav-link view-site" target="_blank">
                                View Website
                            </Link>
                        </li>
                    </ul>
                </nav>
                <div className="admin-logout">
                    <button onClick={handleLogout} className="admin-logout-btn">
                        Logout
                    </button>
                </div>
            </aside>

            {/* Overlay for mobile */}
            {isMobileMenuOpen && (
                <div
                    className="admin-sidebar-overlay"
                    onClick={() => setIsMobileMenuOpen(false)}
                />
            )}

            {/* Main Content */}
            <main className="admin-content">
                <Outlet />
            </main>
        </div>
    );
};

export default AdminLayout;
